"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_google_tag_manager_1 = __importDefault(require("react-google-tag-manager"));
class GoogleTagManager extends react_1.Component {
    componentDidMount() {
        const scriptId = this.props.scriptId || 'react-google-tag-manager-gtm';
        const gtmAdded = document.getElementById('gtmAdded');
        if (!gtmAdded && document) {
            const script = document.createElement('script');
            const gtmScriptNode = document.getElementById(scriptId);
            let scriptText;
            if (gtmScriptNode) {
                const elem = document.createElement('div');
                elem.setAttribute('id', 'gtmAdded');
                document.body.appendChild(elem);
                scriptText = document.createTextNode(gtmScriptNode.textContent);
                script.appendChild(scriptText);
                document.head.appendChild(script);
            }
        }
    }
    render() {
        const gtm = (0, react_google_tag_manager_1.default)({
            id: this.props.gtmId,
            dataLayerName: this.props.dataLayerName || 'dataLayer',
            additionalEvents: this.props.additionalEvents || {},
            previewVariables: this.props.previewVariables || false,
        });
        return (react_1.default.createElement(react_1.Fragment, null,
            gtm.noScriptAsReact(),
            react_1.default.createElement("div", { id: this.props.scriptId || 'react-google-tag-manager-gtm' }, gtm.scriptAsReact())));
    }
}
exports.default = GoogleTagManager;
//# sourceMappingURL=GoogleTagManager.js.map